// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"4158e44c","297":"5231efaf","643":"4347cce9","959":"12c28d9c"}[chunkId] + ".chunk.js";
};